import type { CasinoServiceParameters } from '@ps/web-martech-cms-types';
import type { RaceQueryBlock } from '@ps/web-martech-cms-types/CasinoCompletedRaces';
import produce from 'immer';

type Params = Omit<CasinoServiceParameters, 'ims' | 'include_tags'> & {
  includeTags: CasinoServiceParameters['include_tags'];
  ims: { tags: CasinoServiceParameters['ims']['icon_tags'] };
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export function transformParams(params: CasinoServiceParameters) {
  return produce<any>(params, (draft) => {
    draft.ims.tags = draft.ims.icon_tags;
    delete draft.ims.icon_tags;
    draft.includeTags = draft.include_tags;
    delete draft.include_tags;
    draft.order?.forEach((item: any) => delete item._metadata);
    draft.qry?.forEach((item: any) => {
      if (item.exclude_query_values.length) {
        item.values = item.exclude_query_values;
      }
      delete item.exclude_query_values;
      delete item._metadata;
    });
    if (!draft.bi) delete draft.bi;
  }) as Params;
}
/* eslint-disable @typescript-eslint/no-explicit-any */

interface RaceParams {
  raceQuery: {
    imageTags: string[];
    platformLimit: {
      desktop: number | null;
      tablet: number | null;
      phone: number | null;
    };
    status?: string;
  }[];
}

export function transformRaceParams(params: { race_query: RaceQueryBlock[] }) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return produce<any>(params, (draft) => {
    draft.raceQuery = draft.race_query;
    delete draft.race_query;
    draft.raceQuery.forEach((raceQueryBlock: any) => {
      raceQueryBlock.imageTags = raceQueryBlock.image_tags;
      delete raceQueryBlock.image_tags;
      raceQueryBlock.platformLimit = raceQueryBlock.platform_limit;
      delete raceQueryBlock.platform_limit;
      delete raceQueryBlock._metadata;
    });
  }) as RaceParams;
  /* eslint-disable @typescript-eslint/no-explicit-any */
}
